import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import { FAQTYPES, promoTypes, StaffRole, SWAL_SETTINGS } from "../../../../utils/Constants";
import {
  capitalizeFirstLetter,
  globalLoader,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import * as staffService from "../../services/subadmin.services";
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";
import { useTranslation } from "react-i18next";
import CustomCkeditor from "../../common/customeditor";

const SubAdminEdit = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [saveType, setSaveType] = useState("");
  const [previewimage, setPreviewImage] = useState("");
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("label_sub_admin"), url: "/admin/staff/list/1" },
    { title: t("btn_edit"), url: "" },
  ];
  const [roleData, setRoleData] = useState([]);

  useEffect(() => {
    staffService.Details(params.id)
      .then((response) => {
        const data = response && response.data ? response?.data : {};
        setShowDefault(data);
        setPreviewImage(data.profile_image);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png", "image/gif", "image/webp"];


  useEffect(() => {
    staffService.RoleOptions().then((response) => {
      setRoleData(response?.data || []);
    }).catch((error) => {
      console.log("error=====>", error);
    });
  }, []);

  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required('First name is required'),
    last_name: Yup.string().required('Last name is required'),
    email: Yup.string().email('Invalid email address').required("Email is required"),
    permission_role: Yup.mixed().required("Role is required"),
    files: Yup.mixed()
      .test("fileType", "Only image files are allowed", (value) => {
        if (!value) return true;
        if (typeof value === "string") return true;
        return SUPPORTED_FORMATS.includes(value.type);
      }),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name: showdefault && showdefault.first_name ? showdefault.first_name : "",
      last_name: showdefault && showdefault.last_name ? showdefault.last_name : "",
      permission_role: showdefault.permission_role?._id || showdefault.permission_role || "",
      email: showdefault && showdefault.email ? showdefault.email : "",
      files: showdefault && showdefault.profile_image ? showdefault.profile_image : "",

    },
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      globalLoader(true);
      let formData = new FormData();
      formData.append('profile_image', values.files);
      formData.append('first_name', values.first_name);
      formData.append('last_name', values.last_name);
      formData.append('email', values.email);
      formData.append('permission_role', values.permission_role);
      formData.append('o_id', params.id);
      staffService.Edit(formData)
        .then((response) => {
          setSubmitting(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            if (saveType !== "Save") {
              navigate(`/admin/staff/list/1`);
            }
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
          globalLoader(false);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(error),
            ...SWAL_SETTINGS,
          });
          console.log("error ====> ", error);
        });
    },
  });
  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={formik.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                <div>
                  <h6 className="main-content-label mb-3">
                    {t("btn_edit")} {t("Sub Admin")}
                  </h6>
                </div>
                <div className="row row-sm">
                  <div className="col-md-12 text-center form-group">
                    <label htmlFor="first_name" className="text-left d-flex">
                      {t("First Name")}
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input name="first_name" id="first_name" type="text" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.first_name} className="form-control" />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="first_name" form={formik} />
                    </span>
                  </div>

                  <div className="col-md-12 text-center form-group">
                    <label htmlFor="last_name" className="text-left d-flex">
                      {t("Last Name")}
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input name="last_name" id="last_name" type="text" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.last_name} className="form-control" />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="last_name" form={formik} />
                    </span>
                  </div>

                  <div className="col-md-12 text-center form-group">
                    <label htmlFor="email" className="text-left d-flex">
                      {t("Email")}
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input name="email" id="email" type="text" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.email} className="form-control" />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="email" form={formik} />
                    </span>
                  </div>

                  <div className="col-md-12 text-center form-group">
                    <label htmlFor="permission_role" className="text-left d-flex">
                      Role:
                      <span className="requirestar">*</span>
                    </label>
                    <div className="select-down-arrow">
                      <select name="permission_role" id="permission_role" className="form-control" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.permission_role || ""}>
                        <option value="" disabled>
                          {t("Select Role")}
                        </option>
                        {roleData.map((item) => (
                          <option key={item._id} value={item._id}>
                            {capitalizeFirstLetter(item.title)}
                          </option>
                        ))}
                      </select>
                    </div>
                    {formik.touched.permission_role && formik.errors.permission_role && <span className="text-danger d-flex text-left">{formik.errors.permission_role}</span>}
                  </div>
                  <div className='col-lg-12 text-center form-group'>
                    <label htmlFor='files' className='text-left d-flex'>Profile:</label>
                    <input className='form-control imgInput' id="files" name="files" accept="image/*" type="file" onChange={(event) => {
                      formik.setFieldValue("files", event.currentTarget.files[0] || "");
                      if (event.currentTarget.files.length === 1) {
                        setPreviewImage(URL.createObjectURL(event.currentTarget.files[0]));
                      } else {
                        setPreviewImage("");
                      }
                    }} />

                    {formik.touched.files && formik.errors.files && <span className="text-danger d-flex text-left">{formik.errors.files}</span>}
                  </div>
                  {
                    previewimage ?
                      <div className='mb-4'>
                        <img src={previewimage} style={{ height: "100px" }} alt={""} />
                      </div> : ""
                  }
                  <div className="mt-5">
                    <button
                      onClick={() => {
                        setSaveType("Save");
                      }}
                      className="btn btn-info mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("btn_save")}
                    </button>
                    <button
                      onClick={() => {
                        setSaveType("");
                      }}
                      className="btn btn-success mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("btn_save_exit")}
                    </button>
                    <button className="btn ripple btn-secondary" type="button" onClick={() => navigate("/admin/staff/list/1")}>
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default SubAdminEdit;
